















import { defineComponent } from '@nuxtjs/composition-api'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import { useI18n } from '~/compositions/i18n'
import { dealersFaq } from '~/constants/faq/dealers'

export default defineComponent({
  components: { PlusMinusCollapseOpener, CCollapse },
  setup() {
    const { locale } = useI18n()

    const localeFaq = dealersFaq[locale] || dealersFaq.en

    return { localeFaq }
  },
  head() {
    return {
      title: this.$t('dealers faq') as string
    }
  }
})
